import {
  Component,
  Input,
} from '@angular/core';
import { faAngleRight } from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'app-see-all-button',
  templateUrl: './see-all-button.component.html',
  styleUrls: ['./see-all-button.component.scss'],
})
export class SeeAllButtonComponent {
  @Input() public queryParams: any;
  @Input() public seeAllType: string;
  @Input() public url: string;
  public readonly arrowIconRight = faAngleRight;
}
